import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { formatDateShort } from "../lib/currency";

/**
 * PromoBanner — shown on the ESN dashboard while the summer promo is active.
 * Tone is emerald for the nominal case, amber+CTA for the last 15 days.
 */
export default function PromoBanner({ promo }) {
  const { t } = useTranslation();
  if (!promo || !promo.active) return null;
  const days = promo.days_remaining ?? 0;
  const urgent = days > 0 && days <= 15;
  const tone = urgent
    ? "border-amber-300 bg-amber-50 text-amber-900"
    : "border-emerald-200 bg-emerald-50 text-emerald-900";
  const key = urgent ? "promo.dashboard_urgent" : "promo.dashboard_nominal";
  const endStr = formatDateShort(promo.end_date);
  return (
    <div
      className={`mb-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border ${tone} px-5 py-4 shadow-sm`}
      data-testid="agency-promo-banner"
    >
      <div className="flex items-center gap-3">
        <span className="text-lg">🌞</span>
        <p className="text-sm">
          <span className="font-semibold">{t(`${key}_title`, { days, date: endStr })}</span>{" "}
          <span className="opacity-80">— {t(`${key}_body`, { date: endStr })}</span>
        </p>
      </div>
      {urgent && (
        <Link
          to="/settings/subscription"
          className="rounded-lg bg-amber-900 px-3 py-1.5 text-xs font-semibold text-amber-50 hover:bg-amber-800 whitespace-nowrap"
          data-testid="promo-banner-cta"
        >
          {t("promo.dashboard_urgent_cta")}
        </Link>
      )}
    </div>
  );
}
